export default function createCalendarURI(params) {
    // BEGIN:VCALENDAR
    // VERSION:2.0
    // PRODID:-//Fogo de Chao//NONSGML v1.0//EN
    // BEGIN:VEVENT
    // UID:fetiki@mailinator.net
    // DTSTAMP:2039T46Z
    // ATTENDEE;CN=My Self ;RSVP=TRUE:MAILTO:fetiki@mailinator.net
    // ORGANIZER;CN=Me:MAILTO::fetiki@mailinator.net
    // DTSTART:20190716T113000
    // DTEND:20190716T123000
    // LOCATION:Fogo de Chao, 15 Ave. Munoz Rivera, Suite 208 Puerto Rico 00901
    // SUMMARY:Dinner at Fogo de Chao
    // END:VEVENT
    // END:VCALENDAR

    const convertDate = date => date.toISOString().replace(/-|:|\.\d+/g, '');
    const DTSTART = convertDate(params.startTime);
    const DTEND = convertDate(
        new Date(params.startTime.getTime() + 7200 * 1000),
    );

    const calendarURI = `data:text/calendar;charset=utf8,BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Fogo de Chao//NONSGML v1.0//EN
BEGIN:VEVENT
UID:${params.contactEmail}
ATTENDEE;CN=My Self ;RSVP=TRUE:MAILTO:${params.contactEmail}
ORGANIZER;CN=Me:MAILTO::${params.contactEmail}
DTSTART:${DTSTART}
DTEND:${DTEND}
LOCATION:${params.location}
SUMMARY:${params.summary}
END:VEVENT
END:VCALENDAR
`;

    return encodeURI(calendarURI);
}
